export const TIER_FEATURES = {
  Free: [
    '3 SBC solves per day',
    'Advanced solver algorithm',
    'Community support'
  ],
  Standard: [
    '200 SBC solves per day',
    'Advanced solver algorithm',
    'Priority support',
    'Early access to new features'
  ]
};

export const TIER_PRICES = {
  Free: 0,
  Standard: 2.69
};

export type SubscriptionTier = 'Free' | 'Standard';